export class SecuritySummary {
    'clean';
    'infected';
    'disabled';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "clean",
            "baseName": "clean",
            "type": "number",
            "format": ""
        },
        {
            "name": "infected",
            "baseName": "infected",
            "type": "number",
            "format": ""
        },
        {
            "name": "disabled",
            "baseName": "disabled",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecuritySummary.attributeTypeMap;
    }
    constructor() {
    }
}
